/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect } from 'react';

const Clients = () => {
  useEffect(() => {
    const swiperCtor = window.Swiper;
    if (!swiperCtor || !document.getElementById('clients')) return;

    const swiper = new swiperCtor('#clients', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      breakpoints: {
        450: { slidesPerView: 2, slidesPerGroup: 2 },
        700: { slidesPerView: 3, slidesPerGroup: 3 },
        1000: { slidesPerView: 4, slidesPerGroup: 4 },
        1200: { slidesPerView: 5, slidesPerGroup: 5 }
      },
      pagination: { el: '#clients .swiper-pagination', clickable: true }
    });

    return () => swiper.destroy?.(true, true);
  }, []);

  return (
    <div id="tf-clients" className="text-center">
      <div className="overlay">
        <div className="container">
          <div className="section-title center">
            <h2>Some of <strong> our Clients</strong></h2>
            <div className="line"><hr /></div>
          </div>
          <div id="clients" className="swiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide"><a href="case/mb.pdf"><img src="img/client/mitchells.png" alt="Mitchells" /></a></div>
              <div className="swiper-slide"><img src="img/client/fullers.png" alt="Fullers" /></div>
              <div className="swiper-slide"><a href="case/ph.pdf"><img src="img/client/ph.png" alt="Pizza Hut" /></a></div>
              <div className="swiper-slide"><a href="case/rfu.pdf"><img src="img/client/rfu.png" alt="RFU" /></a></div>
              <div className="swiper-slide"><img src="img/client/bk.png" alt="BK" /></div>
              <div className="swiper-slide"><img src="img/client/marstons.png" alt="Marstons" /></div>
              <div className="swiper-slide"><img src="img/client/kfc.jpg" alt="KFC" /></div>
              <div className="swiper-slide"><img src="img/client/itsu.png" alt="itsu" /></div>
              <div className="swiper-slide"><img src="img/client/foster.png" alt="Foster" /></div>
              <div className="swiper-slide"><img src="img/client/sufc.png" alt="SUFC" /></div>
              <div className="swiper-slide"><img src="img/client/thames.png" alt="Thames" /></div>
              <div className="swiper-slide"><img src="img/client/goldsmith.png" alt="Goldsmith" /></div>
              <div className="swiper-slide"><img src="img/client/byron.jpg" alt="Byron" /></div>
              <div className="swiper-slide"><img src="img/client/travelodge.png" alt="Travelodge" /></div>
              <div className="swiper-slide"><img src="img/client/gbk.png" alt="GBK" /></div>
              <div className="swiper-slide"><img src="img/client/pru.png" alt="Pru" /></div>
              <div className="swiper-slide"><img src="img/client/stirling.png" alt="Stirling" /></div>
              <div className="swiper-slide"><img src="img/client/macdonald.png" alt="Macdonald" /></div>
              <div className="swiper-slide"><a href="case/reading.pdf"><img src="img/client/reading.png" alt="Reading" /></a></div>
              <div className="swiper-slide"><img src="img/client/cambertronic.png" alt="Cambertronic" /></div>
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
